import { CountUp } from 'countup.js';

const ragg = document.querySelector('[data-raggiungimenti]');

if (ragg) {
    const raggNumbers = ragg.querySelectorAll('[data-value]');

    const options = {
        separator: '.',
        decimal: ',',
    };

    const observer = new IntersectionObserver(
        (entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                    // Elemento completamente visibile
                    raggNumbers.forEach((number) => {
                        const valore = number.getAttribute('data-value');
                        const conta = new CountUp(number, valore, options);
                        if (!conta.error) {
                            conta.start();
                        }
                    });

                    // Disconnetti l'observer per evitare ripetizioni
                    observer.disconnect();
                }
            });
        },
        {
            threshold: 0.5, // Tutto l’elemento deve essere visibile
        },
    );

    observer.observe(ragg);
}
